import React from "react";
import MyForm from "./MyForm";
function App() {
  return (
    <div className="App">
      <MyForm/>
    </div>
  );
}

export default App;
